import React, { useEffect, useState } from 'react';
import Loading from '../../../utils/Loading';
import { getKategorije, getPodkategorijeByKategorijaId, getSkupOblastiByPodkategorijaId, updateListeSkupOblasti } from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import { DragDropContext } from 'react-beautiful-dnd';
import { Droppable } from 'react-beautiful-dnd';
import { Draggable } from 'react-beautiful-dnd';
import { FaEdit } from 'react-icons/fa';
import AddSkupOblastiModal from './AddSkupOblastiModal';

function SkupOblastiHome() {
    const [loading, setLoading] = useState(false);
    const [kategorije, setKategorije] = useState<any>([]);
    const [podkategorije, setPodkategorije] = useState<any>([]);
    const [skupOblastiList, setSkupOblastiList] = useState<any>([]);
    const [selectedKategorija, setSelectedKategorija] = useState<any>(null);
    const [selectedPodkategorija, setSelectedPodkategorija] = useState<any>(null);
    const [selectedSkupOblasti, setSelectedSkupOblasti] = useState<any>(null);
    const [addSkupOblastiModalOpen, setAddSkupOblastiModalOpen] = useState(false);

    useEffect(() => {
        loadKategorije();
    }, []);

    const loadKategorije = async () => {
        const resp = await getKategorije();
        if (resp.status === 200) {
            setKategorije(resp.data);
        }
    };

    const fetchPodkategorije = async (item: any) => {
        setSelectedKategorija(item);
        const resp = await getPodkategorijeByKategorijaId(item?.id);
        if (resp.status === 200) {
            setPodkategorije(resp.data);
        }
    };

    const fetchSkupOblasti = async (item: any) => {
        setSelectedPodkategorija(item);
        const resp = await getSkupOblastiByPodkategorijaId(item?.id);
        if (resp.status === 200) {
            setSkupOblastiList(resp.data);
        }
    };

    const closeAddSkupOblastiModal = () => {
        setSelectedSkupOblasti(null);
        setAddSkupOblastiModalOpen(false);
    };
    const openAddSkupOblastiModal = (item: any) => {
        setSelectedSkupOblasti(item);
        setAddSkupOblastiModalOpen(true);
    };

    const updateRedosledSkupOblasti = async (lista: any) => {
        setLoading(true);
        const resp = await updateListeSkupOblasti(lista);
        if (resp.status == 201) {
            notif('Uspešno ste promenili raspored skup oblasti u listi.');
            setSkupOblastiList(resp.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const handleDrop = (droppedItem: any) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...skupOblastiList];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        let newReorderList = updatedList.map((item, index) => {
            return { ...item, redosled: index + 1 };
        });
        // Update State
        // setPodkategorije(newReorderList);
        updateRedosledSkupOblasti(newReorderList);
    };

    return (
        <div className="p-5 h-full">
            <div className="grid grid-cols-4 gap-3 h-full ">
                <div className="h-full overflow-auto ">
                    <div className="flex flex-row items-center  h-12">
                        <label className="text-[16px] leading-5 text-black font-semibold  ">
                            Lista postojecih kategorija <span>(ukupno {kategorije.length})</span>{' '}
                        </label>
                    </div>
                    {kategorije
                        .sort((a: any, b: any) => a.redosled - b.redosled)
                        .map((item: any, index: number) => {
                            return (
                                <div
                                    className={` border border-black rounded-[4px] px-6 py-[5px] mt-1 flex flex-row items-center justify-between cursor-pointer ${
                                        item.id === selectedKategorija?.id ? 'bg-blueSuperLight' : 'bg-white'
                                    }`}
                                    key={index}
                                    onClick={() => fetchPodkategorije(item)}
                                >
                                    <div>
                                        <p className="text-[14px] leading-[18px]">
                                            Naziv: <span className="font-bold">{item.naziv}</span>
                                        </p>
                                        <p className="text-[14px] leading-[18px]">Redosled: {item.redosled}</p>
                                        <p className="text-[14px] leading-[18px]" style={{ color: item.visible ? 'black' : 'red' }}>
                                            Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                <div className="h-full overflow-auto ">
                    <div className="flex flex-row items-center  h-12">
                        <label className="text-[16px] leading-5  font-semibold  ">
                            Lista postojecih potkategorija <span>(ukupno {podkategorije.length})</span>{' '}
                        </label>
                    </div>
                    {podkategorije
                        .sort((a: any, b: any) => a.redosled - b.redosled)
                        .map((item: any, index: number) => {
                            return (
                                <div
                                    className={` border border-black rounded-[4px] px-6 py-[5px] mt-1 flex flex-row items-center justify-between cursor-pointer ${
                                        item.id === selectedPodkategorija?.id ? 'bg-blueSuperLight' : 'bg-white'
                                    }`}
                                    key={index}
                                    onClick={() => fetchSkupOblasti(item)}
                                >
                                    <div>
                                        <p className="text-[14px] leading-[18px]">
                                            Naziv: <span className="font-bold">{item.naziv}</span>
                                        </p>
                                        <p className="text-[14px] leading-[18px]">Redosled: {item.redosled}</p>
                                        <p className="text-[14px] leading-[18px]" style={{ color: item.visible ? 'black' : 'red' }}>
                                            Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                {!!selectedPodkategorija && (
                    <div className="h-full overflow-auto col-span-2">
                        <div className="flex flex-row items-center justify-between gap-1">
                            <label className="text-[16px] leading-5 font-semibold  ">
                                Lista postojecih skupova oblasti <span>(ukupno {skupOblastiList.length})</span>{' '}
                            </label>
                            <button
                                className={`px-3 h-[48px] flex items-center justify-center bg-white border border-black rounded-[4px] text-[16px] leading-5 font-semibold `}
                                onClick={(e) => openAddSkupOblastiModal(null)}
                            >
                                <p>Dodaj novi skup oblasti</p>
                            </button>
                        </div>
                        <DragDropContext onDragEnd={handleDrop}>
                            <Droppable droppableId="list-container">
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {skupOblastiList
                                            .sort((a: any, b: any) => a.redosled - b.redosled)
                                            .map((item: any, index: number) => {
                                                return (
                                                    <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                                        {(provided) => (
                                                            <div
                                                                className="bg-white border border-black200 rounded-[4px] px-6 py-[5px] mt-1 flex flex-row items-center justify-between"
                                                                key={index}
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <div>
                                                                    <p className="text-[14px] leading-[18px]">
                                                                        Naziv: <span className="font-bold">{item.naziv}</span>
                                                                    </p>
                                                                    <p className="text-[14px] leading-[18px]">Redosled: {item.redosled}</p>
                                                                    <p className="text-[14px] leading-[18px]" style={{ color: item.visible ? 'black' : 'red' }}>
                                                                        Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                                                    </p>
                                                                </div>
                                                                <div className=" cursor-pointer p-2 " onClick={() => openAddSkupOblastiModal(item)}>
                                                                    <FaEdit style={{ width: 20, height: 20 }} />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                );
                                            })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                )}
            </div>
            <AddSkupOblastiModal
                modalIsOpen={addSkupOblastiModalOpen}
                closeModal={closeAddSkupOblastiModal}
                kategorija={selectedKategorija}
                podkategorija={selectedPodkategorija}
                skupOblasti={selectedSkupOblasti}
                reloadSkupOblastiList={fetchSkupOblasti}
            />
        </div>
    );
}

export default SkupOblastiHome;
